import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { GiLotusFlower } from 'react-icons/gi';
import ProductCard from '../components/ProductCard';
import Loader from '../components/Loader';

const API = process.env.REACT_APP_API_URL;

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/api/products`)
      .then(res => setProducts(Array.isArray(res.data) ? res.data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#FDF6E3', paddingTop: '6rem' }}>

      {/* Page Header */}
      <section style={{
        background: 'linear-gradient(135deg, #2C1810, #4a2010)',
        padding: '4rem 2rem', textAlign: 'center', marginBottom: '3rem'
      }}>
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <GiLotusFlower size={40} color="#D4AF37" />
          <h1 style={{
            fontFamily: 'Cinzel', color: '#F5D76E',
            fontSize: 'clamp(1.8rem, 5vw, 3rem)',
            letterSpacing: '6px', margin: '0.8rem 0'
          }}>
            OUR PRODUCTS
          </h1>
          <div style={{
            height: '1px', width: '200px', margin: '0.8rem auto',
            background: 'linear-gradient(to right, transparent, #D4AF37, transparent)'
          }} />
          <p style={{ color: '#c9a96e', fontFamily: 'Crimson Text', fontSize: '1.1rem' }}>
            Pure • Natural • Handcrafted with Devotion
          </p>
        </motion.div>
      </section>

      {/* Products Grid */}
      <section style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem 5rem' }}>
        {loading ? <Loader /> : products.length === 0 ? (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}
            style={{ textAlign: 'center', padding: '5rem 0' }}>
            <GiLotusFlower size={50} color="#D4AF37" />
            <h3 style={{ fontFamily: 'Cinzel', color: '#8B6914', marginTop: '1rem', letterSpacing: '3px' }}>
              Products Coming Soon
            </h3>
            <p style={{ color: '#c9a96e', fontFamily: 'Crimson Text' }}>
              Our sacred collection is being prepared with love 🙏
            </p>
          </motion.div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(270px, 1fr))',
            gap: '2rem'
          }}>
            {products.map((p, i) => (
              <motion.div key={p._id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}>
                <ProductCard product={p} />
              </motion.div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Products;